import React from "react";

import "./App.css";

import Home from "./pages/Home";

function App() {
  return <Home data-testid="elem-1" />;
}

export default App;
